export class StringUtils {

    static trimLeft(str: string, charList: string) {
        return str.replace(new RegExp("^[" + charList + "]+"), "");
    }
}